import { alert as baseAlert } from 'miniapp-web-jsapi/lib/web/jsapi/alert';
export default function alert(options) {
  return baseAlert(options);
}